import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectConfig } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'

const useExportLogs = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const [logs, setLogs] = useState([])
  const { contactId } = useSelector(selectConfig)
  const { isAdmin } = useSelector(selectAuthData)

  const closeModal = () => {
    setIsOpen(false)
  }

  const subscriptionLogsHandler = (response, statusCode) => {
    if (statusCode === 200 && response && response.length > 0) {
      setLogs(response)
    }
    setIsOpen(true)
  }

  const fetchSubscriptionLogs = () => {
    dispatch({
      type: subscriptionFormActionsV2.EXPORT_LOGS_V2,
      callback: subscriptionLogsHandler,
      contactId
    })
  }

  return {
    t,
    isAdmin,
    isOpen,
    logs,
    closeModal,
    fetchSubscriptionLogs
  }
}

export default useExportLogs
